//============================================================================
// Name        : scheduleActions.ts
// Purpose     : Define store Schedule actions
// Created     : 2019-08-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import Moment from "moment";
import { extendMoment } from "moment-range";
import { IInspectSoItemsResp, IScheduleState, ScheduleActions } from "../types";

// Add Ranges plugin for MomentJS
const moment = extendMoment(Moment);

// Define base Action interface
export interface IScheduleAction {
    type: ScheduleActions;
    payload: object;
}

//================================ Actions ===================================

//============================================================================
// Updates the store state with given values
//============================================================================
export interface IUpdateStateAction extends IScheduleAction {
    payload: IScheduleState;
}
export function updateState(state: IScheduleState, action: IUpdateStateAction): IScheduleState {
    return {
        ...state,
        ...action.payload
    };
}

export interface IShowSOInspectDialogAction extends IScheduleAction {
    inspectSO: IInspectSoItemsResp;
}
export function showSOInspectDialog(state: IScheduleState, action: IShowSOInspectDialogAction): IScheduleState {
    return {
        ...state,
        inspectSO: action.inspectSO,
        showSOInspect: true
    };
}

export function hideSOInspectDialog(state: IScheduleState): IScheduleState {
    return {
        ...state,
        showSOInspect: false
    };
}
